import React from 'react';
import { COMPANY_INFO } from '../data';

const SCROLL_ITEMS = [
  "ENERGIRUDER",
  "GRATIS BESØG",
  "VARMEBESPARELSE",
  "RÅDGIVNING",
  "UDSKIFTNING AF RUDER",
  "BEDRE INDEKLIMA",
  "PROFESSIONEL MONTERING"
];

export default function DynamicScrollbar() {
  // Duplicate items to ensure smooth infinite loop
  const doubledItems = [...SCROLL_ITEMS, ...SCROLL_ITEMS, ...SCROLL_ITEMS, ...SCROLL_ITEMS];

  return (
    <>
      <div className="bg-brand-blue text-white py-4 overflow-hidden relative select-none border-y border-brand-blue/30 shadow-sm mb-0">
        <div className="flex w-max animate-marquee whitespace-nowrap">
          {doubledItems.map((item, idx) => (
            <div key={idx} className="flex items-center mx-8">
              <span className="text-sm sm:text-base font-bold tracking-[0.15em] uppercase">
                {item}
              </span>
              <span className="ml-16 text-brand-light/40 font-bold text-lg">•</span>
            </div>
          ))}
        </div>
      </div>

      <div className="bg-brand-warm py-8 border-b border-brand-deep/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 md:grid-cols-12 items-center gap-6 md:gap-12">
          {/* Venstre side: Tekst og knap */}
          <div className="md:col-span-6 flex flex-col items-center md:items-start text-center md:text-left gap-4">
            <h3 className="text-xl sm:text-2xl font-bold text-brand-dark uppercase tracking-wide">
              Hvad siger vores kunder?
            </h3>
            <p className="text-xs sm:text-sm text-brand-dark/70 leading-relaxed">
              Du har også mulighed for at se, hvad andre kunder siger om mit firma og det udførte arbejde. Vi lægger stor vægt på personlig service, høj kvalitet og fuld gennemsigtighed i alle vores glarmesteropgaver. Din tryghed er vores vigtigste prioritet, og vi er stolte af de mange positive tilbagemeldinger, vi løbende modtager.
            </p>
            <div className="flex flex-col sm:flex-row gap-3 w-full sm:w-auto mt-2">
              <a 
                href={COMPANY_INFO.trustpilotUrl}
                target="_blank" 
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center px-6 py-3 bg-brand-blue text-white font-bold text-sm hover:bg-brand-deep transition-colors uppercase tracking-wider"
              >
                Se Trustpilot <i className="fa-solid fa-star ml-2 text-xs" />
              </a>
            </div>
          </div>

          {/* Højre side: Billede (col-6) */}
          <div className="flex md:col-span-6 justify-center md:justify-end w-full">
            <img 
              src="https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=90,format=auto/assets/8d0f5bf2-9099-44a5-baa5-a4be578e55f8/energirude-eksperten-kundebedoemmelser-banner.png" 
              alt="Energirude Eksperten med over 50 anbefalinger på håndværker.dk" 
              className="w-full max-w-xl h-auto object-contain"
            />
          </div>
        </div>
      </div>
    </>
  );
}
